import { randomBytes } from "crypto";
import { BackendFlavor as BackendFlavorType } from "@/types/session";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateId(): string {
  return randomBytes(16).toString("hex");
}

// Backend flavor metadata interface
// This structure matches the API response from /api/backend-flavors
export interface BackendFlavor {
  name: string;
  displayName: string;
  version: string;
  tierRequirement: number;
  description: string;
  tags: string[];
  healthy?: boolean; // Runtime health status from API
  podCount?: number; // Number of healthy pods from API
}

// Note: Backend flavors are now dynamically loaded from YAML configuration
// Components should fetch flavors from the API using api.backendFlavors.list.useQuery()
// instead of using a hardcoded array

// Helper to validate flavor strings at runtime
// Now accepts any non-empty string since flavors are dynamically configured
export function isValidFlavor(flavor: string): flavor is BackendFlavorType {
  return typeof flavor === "string" && flavor.trim().length > 0;
}
